const store = {
    namespaced: true,
    state: {
        stations: [],
    },
}
export default store
